import { publishEvent } from "../../../../notification-locators/PubSubService";
import { ServiceEvent } from "../../../services/events/ServiceEvent";
import { MessageLog } from "@qandq/cloud-gcs-core";

export const publishServiceMessageLog = (log: MessageLog) => {
  publishEvent(ServiceEvent.InsertSummaryLog, log);
};
